import { getBundle } from 'app/dux/cmx/actions';
import { connect } from 'react-redux';
import SaveButton from './SaveButton';

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = {
    getBundle
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveButton);
